var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserFriend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M5.245 13.071c.719.335 1.51.536 2.355.536a5.52 5.52 0 002.355-.536h.286c2.187.002 3.959 1.729 3.959 3.859v.963c0 .887-.739 1.607-1.65 1.607h-9.9c-.911 0-1.65-.72-1.65-1.607v-.964c0-2.13 1.773-3.857 3.96-3.858zm10.736 0c.477.161.983.268 1.519.268a4.74 4.74 0 001.52-.268h.134c2.125.001 3.847 1.68 3.846 3.75l-.006.14c-.072.822-.78 1.468-1.644 1.468h-6.07c.003-.07.02-.141.02-.215V16.93c0-1.293-.526-2.461-1.365-3.342a3.898 3.898 0 011.915-.516zm1.519-7.5c1.823 0 3.3 1.44 3.3 3.215S19.323 12 17.5 12l-.187-.005C15.577 11.9 14.2 10.5 14.2 8.785l.005-.182c.097-1.69 1.535-3.032 3.295-3.032zM7.6 4.5c2.126 0 3.85 1.679 3.85 3.75 0 2.071-1.724 3.75-3.85 3.75-2.13-.001-3.851-1.68-3.85-3.75 0-2.07 1.724-3.75 3.85-3.75z"
  }))));
}

export default SvgUserFriend;